import type { Response } from '../types/basicFetch';

export function isRetryableSegmentResponse(response: Response): boolean {
  return response.status === 404 // For ongoing live recordings, it could happen that a segment is requested before S3 is ready
    || response.status === 400 // Local stage S3 responds with 400 for missing files for some reason instead of 404
    || response.status === 429
    || response.status >= 500;
}



